import { createSelector } from '@ngrx/store';

import { RootState } from '../root-store/root.state';

const selectSeEnvironment = (state: RootState) => state.environment;

export const selectSeEnvironmentIsStandalone = createSelector(selectSeEnvironment, (env) => env.isStandalone);
export const selectSeEnvironmentIsProduction = createSelector(selectSeEnvironment, (env) => env.production);
